// extracted by mini-css-extract-plugin
export default {"dataSimplebar":"AppScrollbar_dataSimplebar__hsetF"};